import "../Services/services.css";
import { CardsContainer, NavBar } from "../index";

const Services = () => {
  return (
    <div className="main">
      <NavBar />
      <div>
        <CardsContainer />
      </div>
    </div>
  );
};

export default Services;
